<div mat-dialog-title class="flex flex-row items-center justify-between border-b border-gray-200 px-6 py-2 mb-4">
  <h3 class="flex-1 m-0 font-semibold">{{ 'survey.title' | translate }}</h3>
  <flow-button class="absolute right-4 top-3" theme="light" type="button" (onClick)="onNotNowClick()">
    <app-icon stroke="#202020" size="md" iconName="x"></app-icon>
  </flow-button>
</div>

<mat-dialog-content class="px-6">
  <iframe
    [attr.data-tally-src]="embedSrc"
    loading="lazy"
    width="100%"
    height="500"
    frameborder="0"
    marginheight="0"
    marginwidth="0"
    [title]="'survey.title' | translate"></iframe>
</mat-dialog-content>

<div mat-dialog-actions class="flex flex-row justify-end w-full items-center p-6 pt-0">
  <flow-button theme="secondary" variation="outline" (onClick)="onNotNowClick()">
    {{ 'survey.notNow' | translate }}
  </flow-button>
</div>
